<template>
  <div class="services-section">
    <LayoutSection size="o5v90">
      <PreviousPageBtn :label-code="previoueBtnName" :class="'mt-40'" />
      <el-row>
        <el-col class="text-left p-9" :xs="12" :sm="8" :md="8">
          <div class="bg-accent-light text-center p-20 mt-15">
            <img :src="servicesImage" class="services-image" />
          </div>
        </el-col>
        <el-col class="text-left p-9 faq-tile" :xs="12" :sm="16" :md="16">
          <h2 class="mb-13 text-left page-title mt-150">
            {{ $t("faq.services.title") }}
          </h2>
        </el-col>
      </el-row>
      <el-row>
        <el-col :xs="12" :sm="12" :md="12" :offset="6" class="mt-50">
          <el-tabs v-model="tabActiveName">
            <el-tab-pane
              :label="$i18n.t('faq.services.tabList.boires')"
              name="first"
            >
              <el-collapse v-model="activeNames"> 
                <el-collapse-item
                  v-for="boires in boiresQuestion"
                  :key="boires.question"
                  :title="boires.question"
                  :name="boires.question"
                  class="service-questions"
                >
                  <div v-html="boires.answer" class="text-left answer"></div>
                </el-collapse-item>
              </el-collapse>
            </el-tab-pane>
            <el-tab-pane
              :label="$i18n.t('faq.services.tabList.ressourcesHumaines')"
              name="second"
            >
              <el-collapse v-model="activeNames">
                <el-collapse-item
                  v-for="ressources in ressourcesQuestion"
                  :key="ressources.question"
                  :title="ressources.question"
                  :name="ressources.question"
                >
                  <div
                    v-html="ressources.answer"
                    class="text-left answer"
                  ></div>
                </el-collapse-item>
              </el-collapse>
            </el-tab-pane>
            <el-tab-pane
              :label="$i18n.t('faq.services.tabList.producteurs')"
              name="third"
            >
              <el-collapse v-model="activeNames">
                <el-collapse-item
                  v-for="producteurs in producteursQuestion"
                  :key="producteurs.question"
                  :title="producteurs.question"
                  :name="producteurs.question"
                >
                  <div
                    v-html="producteurs.answer"
                    class="text-left answer"
                  ></div>
                </el-collapse-item>
              </el-collapse>
            </el-tab-pane>
            <el-tab-pane
              :label="$i18n.t('faq.services.tabList.services')"
              name="fourth"
            >
              <el-collapse v-model="activeNames">
                <el-collapse-item
                  v-for="services in servicesQuestion"
                  :key="services.question"
                  :title="services.question"
                  :name="services.question"
                >
                  <div v-html="services.answer" class="text-left answer"></div>
                </el-collapse-item>
              </el-collapse>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
    </LayoutSection>
  </div>
</template>

<script>
import LayoutSection from "@/components/layout/layout-section.vue";
import PreviousPageBtn from "@/components/previous-page-btn.vue";

export default {
  components: {
    LayoutSection,
    PreviousPageBtn,
  },
  data() {
    return {
      previoueBtnName: "FrequentlyAskedQuestions",
      activeNames: [""],
      tabActiveName: "first",
    };
  },
  computed: {
    servicesImage() {
      return require("@/assets/images/faq/services/services.png");
    },
    boiresQuestion() {
      return this.$i18n.t("faq.services.boires");
    },
    ressourcesQuestion() {
      return this.$i18n.t("faq.services.ressources");
    },
    producteursQuestion() {
      return this.$i18n.t("faq.services.producteurs");
    },
    servicesQuestion() {
      return this.$i18n.t("faq.services.services");
    },
  },
  methods: {},
};
</script>

<style>
.services-section {
  margin-bottom: 50px;
}
.services-image {
  height: auto;
  width: 100%;
}
.faq-tile-desscription {
  margin-top: 10px;
}
.services-tile-title {
  font-size: 18px;
  font-weight: bold;
}
.el-collapse-item__header {
  font-size: 20px;
}
.answer {
  font-size: 15px;
}
.el-collapse {
  border-top: 0;
}
.page-title {
  font-family: 'Futura LT Book', 'Futura', sans-serif;
  font-size: 48px;
}
.service-questions {
  font-family: 'ArialMT', 'Arial', sans-serif;
}
</style>